
export class ReqRoleAdd {
    constructor({ departmentId, roleName, isSupervisor}) {
        this.departmentId = departmentId
        this.roleName = roleName
        this.isSupervisor = isSupervisor
    }
    fromJson(jsonDate) {
        this.departmentId = jsonDate.departmentId
        this.roleName = jsonDate.roleName
        this.isSupervisor = jsonDate.isSupervisor
        this.managerRoleId = jsonDate.managerRoleId===undefined?"":jsonDate.managerRoleId
        this.isDisable = jsonDate.isDisable===undefined?0:jsonDate.isDisable
        this.isInit = jsonDate.isInit===undefined?0:jsonDate.isInit
        this.note = jsonDate.note===undefined?"":jsonDate.note
    }

}

export class ReqRoleDetail {
    constructor({ roleId }) {
        this.roleId = roleId
    }

    fromJson(jsonDate) {
        this.roleId = jsonDate.roleId
    }

}

export class RespRoleDetail {

    fromJson(jsonDate) {
        this.roleId = jsonDate.roleId
        this.departmentId = jsonDate.departmentId
        this.roleName = jsonDate.roleName
        this.isSupervisor = jsonDate.isSupervisor
        this.managerRoleId = jsonDate.managerRoleId===undefined?"":jsonDate.managerRoleId
        this.isDisable = jsonDate.isDisable===undefined?0:jsonDate.isDisable
        this.isInit = jsonDate.isInit===undefined?0:jsonDate.isInit
        this.note = jsonDate.note===undefined?"":jsonDate.note
    }
}

export class ReqUpdateRole {
    constructor({ departmentId, roleId, roleName, isSupervisor}) {
        this.departmentId = departmentId
        this.roleId = roleId
        this.roleName = roleName
        this.isSupervisor = isSupervisor
    }
    fromJson(jsonDate) {
        this.departmentId = jsonDate.departmentId
        this.roleId = jsonDate.roleId
        this.roleName = jsonDate.roleName
        this.isSupervisor = jsonDate.isSupervisor
        this.managerRoleId = jsonDate.managerRoleId===undefined?"":jsonDate.managerRoleId
        this.isDisable = jsonDate.isDisable===undefined?0:jsonDate.isDisable
        this.isInit = jsonDate.isInit===undefined?0:jsonDate.isInit
        this.note = jsonDate.note===undefined?"":jsonDate.note
    }
}